import AuthZeroErrorMessage from './component.jsx'
export default AuthZeroErrorMessage
